import { Col, Row } from "antd";
import React from "react";

export const ListadoTitulo = () => {
  return (
    <Row>
      <Col span={13} style={{ textAlign: "center", fontWeight: 600 }}>
        Motivo
      </Col>
      <Col span={5} style={{ textAlign: "center", fontWeight: 600 }}>
        Fecha Inicial
      </Col>
      <Col span={5} style={{ textAlign: "center", fontWeight: 600 }}>
        Fecha fianl
      </Col>
      <Col span={1}></Col>
    </Row>
  );
};
